var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.906 7.563a1.719 1.719 0 1 0 0 3.437 1.719 1.719 0 0 0 0-3.438zM14.094 7.563a1.719 1.719 0 1 0 0 3.437 1.719 1.719 0 0 0 0-3.438z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 11a9.626 9.626 0 1 0-14.507 8.28l.011.106a1.37 1.37 0 0 0 1.368 1.24h7.006a1.37 1.37 0 0 0 1.368-1.239l.01-.108A9.603 9.603 0 0 0 20.626 11zM11 2.75a8.243 8.243 0 0 1 8.23 7.836l-3.58 1.79h-9.3l-3.579-1.79A8.243 8.243 0 0 1 11 2.75zm-8.168 9.404 2.71 1.354.399 3.994a8.23 8.23 0 0 1-3.109-5.348zm11.67 7.096H7.498l-.55-5.5h8.106l-.55 5.5zm1.557-1.747.4-3.995 2.709-1.354a8.23 8.23 0 0 1-3.109 5.349z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientIcon);
export default __webpack_public_path__ + "static/media/patientIcon.f9b60136f7346f4eaef4031cf9c7f879.svg";
export { ForwardRef as ReactComponent };